import Accordion from '../Hbs/modules/accordion/Accordion';
import Credits from '../Hbs/modules/credits/Credits';

class Default {
  constructor() {
    this.burgerToggle();
    this.searchToggle();

    new Accordion();
    new Credits();
  }

  public searchToggle() {
    let toggleElement = document.querySelector('.search-toggle'),
        searchInput = document.querySelector('#search-input'),
        searchSubmit = document.querySelector('#search-submit');

    toggleElement.addEventListener('click', function(event: Event) {
      event.preventDefault();
      toggleElement.classList.toggle('active');
      searchInput.classList.toggle('animate-in');
      searchSubmit.classList.toggle('animate-in');
    })
  }

  public burgerToggle() {
    let burger = document.querySelector('.menu-toggle'),
        header = document.querySelector('header');

    if (burger) {
      burger.addEventListener('click', () => {
        burger.classList.toggle('burger')
        burger.classList.toggle('times')
        header.classList.toggle('active')
      })
    }
  }
}

new Default();

export default Default;
